import styled from 'styled-components';
import {
  ArrowRightIcon,
  FlexRow,
  matchSize,
  SvgIcon,
} from '@make-software/cspr-design';
import { PaginationArrowButton } from '../table-settings/pagination-button';
import React from 'react';

export enum SectionPaginationType {
  'simplePagination' = 'simplePagination',
  'extendedPagination' = 'extendedPagination',
}

const SectionPaginationContainer = styled(FlexRow)<{ withBorder?: boolean }>(
  ({ theme, withBorder }) =>
    theme.withMedia({
      justifyContent: 'flex-end',
      padding: '16px 0',
      width: '-webkit-fill-available',
      position: 'relative',
      ...(withBorder && {
        ':after': {
          content: "''",
          position: 'absolute',
          left: 0,
          right: 0,
          top: 0,
          borderBottom: theme.border.tableRowSeparator,
        },
      }),
      margin: 0,
    })
);
const getSize = (type: SectionPaginationType) =>
  matchSize(
    {
      [SectionPaginationType.simplePagination]: '24px',
      [SectionPaginationType.extendedPagination]: '36px',
    },
    type
  );

const SectionPaginationArrowButton = styled(PaginationArrowButton)<{
  type?: SectionPaginationType;
}>(({ theme, type }) =>
  theme.withMedia({
    height: getSize(type),
    width: getSize(type),
  })
);

const MirroredSvgIcon = styled(SvgIcon)(({ theme }) => ({
  transform: 'rotate(180deg)',
}));

export interface SectionTablePaginationProps {
  pageCount?: number;
  currentPage?: number;
  setCurrentPage?: (page: number) => void;
  paginationType?: SectionPaginationType;
}

export function SectionTablePagination({
  pageCount = 1,
  currentPage = 1,
  setCurrentPage = () => {},
  paginationType = SectionPaginationType.simplePagination,
}: SectionTablePaginationProps) {
  const prevPageHandler = () => {
    setCurrentPage(currentPage - 1);
  };

  const nextPageHandler = () => {
    setCurrentPage(currentPage + 1);
  };

  const isPrevEnabled = currentPage > 1;
  const isNextEnabled = currentPage < pageCount;

  if (pageCount < 1) {
    return null;
  }

  const iconSize =
    paginationType === SectionPaginationType.extendedPagination ? 36 : 24;

  return (
    <SectionPaginationContainer
      height={iconSize}
      itemsSpacing={15}
      withBorder={paginationType === SectionPaginationType.simplePagination}
    >
      <SectionPaginationArrowButton
        color={'secondaryRed'}
        disabled={!isPrevEnabled}
        onClick={prevPageHandler}
        type={paginationType}
      >
        <MirroredSvgIcon src={ArrowRightIcon} alt={'Arrow left icon'} />
      </SectionPaginationArrowButton>
      <SectionPaginationArrowButton
        color={'secondaryRed'}
        disabled={!isNextEnabled}
        onClick={nextPageHandler}
        type={paginationType}
      >
        <SvgIcon src={ArrowRightIcon} alt={'Arrow right icon'} role={'img'} />
      </SectionPaginationArrowButton>
    </SectionPaginationContainer>
  );
}
export default SectionTablePagination;
